import React, { useState } from 'react'
import KnowledgeCard from './components/KnowledgeCard'
import VideoPreview from './components/VideoPreview'
import AddKnowledgeSourceModal from './components/AddKnowledgeSourceModal'
import {
  Container,
  MainContent,
  Header,
  HeaderIconWrapper,
  HeaderIcon,
  HeaderTitle,
  Description,
  SubDescription,
  UpgradeButton,
  CardsContainer
} from './components/KnowledgeStyles'

const KNOWLEDGE_CARDS = [
  {
    icon: '🌐',
    title: 'Crawl webpages',
    description: 'Scrape the content from public URLs like your website or help center.'
  },
  {
    icon: '📄',
    title: 'Upload files',
    description:
      'Add key background info from text-based files such as .txt, .csv, .pdf, .doc. Up to 2MB each.'
  },
  {
    icon: '🔄',
    title: 'Connect Tables',
    description:
      'Sync frequently asked questions and resources stored in a Botgo Table. 10,000 rows each.'
  }
]
interface Iprops {
  getInformation: any
  getInformationDetails: any
}

const KnowledgeSection: React.FC<Iprops> = ({ getInformation, getInformationDetails }) => {
  const [isModalOpen, setIsModalOpen] = useState(false)

  return (
    <Container>
      <MainContent>
        <Header>
          <HeaderIconWrapper>
            <HeaderIcon>📚</HeaderIcon>
          </HeaderIconWrapper>
          <HeaderTitle>Connect custom knowledge</HeaderTitle>
        </Header>

        <Description>
          Train your chatbot on knowledge that is unique to your project or business so it can
          provide accurate answers instantly — responding just like you would.
        </Description>

        <SubDescription>
          Start by connecting public links, tables, and files — up to 10 on Pro and 20 on Advanced
          for each Chatbot. Then, set a sync schedule to keep everything up to date. Finally, define
          fallback logic for when answers aren't found.
        </SubDescription>

        <CardsContainer>
          {KNOWLEDGE_CARDS.map((card, index) => (
            <KnowledgeCard
              key={card.title}
              icon={card.icon}
              title={card.title}
              description={card.description}
            />
          ))}
        </CardsContainer>
        <UpgradeButton onClick={() => setIsModalOpen(true)} className='mt-10'>
          <span style={{ marginRight: 8, fontWeight: 'bold', fontSize: 18 }}>+</span>
          Add your first knowledge source
        </UpgradeButton>
      </MainContent>

      <VideoPreview />
      {/* Modal for adding knowledge source */}
      {isModalOpen && (
        <AddKnowledgeSourceModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          getInformation={getInformation}
          getInformationDetails={getInformationDetails}
        />
      )}
    </Container>
  )
}

export default KnowledgeSection
